export default __webpack_public_path__ + "static/media/payment-box-icon-05.2bf02647.png";